import { State } from './reducer';
import { PayloadAction } from '@reduxjs/toolkit';

export const setModalOpen = (state: State, action: PayloadAction<boolean>) => {
	state.modalOpen = action.payload;
};
